import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import {
  LENH_BOT_SCANBM_ROUTE_NAME,
  LENH_BOT_CHECKTKQC_ROUTE_NAME,
  SHARE_TKQC_ROUTE_NAME,
  SHARE_PIXEL_ROUTE_NAME,
  CREATE_CATALOGUE_ROUTE_NAME,
  SET_LIMIT_ROUTE_NAME,
  REMOVE_LIMIT_ROUTE_NAME,
  RENAME_TKQC_ROUTE_NAME,
  RENAME_PAGE_ROUTE_NAME,
} from '@/navigation/lenh-bot'

const LoginPage = () => import('@/pages/LoginPage.vue')
const AdminLayout = () => import('@/components/layout/AdminLayout.vue')
const AssetsPage = () => import('@/pages/AssetsPage.vue')
const CsManagementPage = () => import('@/pages/CsManagementPage.vue')
const UserManagementPage = () => import('@/pages/UserManagementPage.vue')
const RolePermissionPage = () => import('@/pages/RolePermissionPage.vue')
const LenhBotShareTkqcPage = () => import('@/pages/lenh-bot/ShareTkqcPage.vue')
const LenhBotSharePagePage = () => import('@/pages/lenh-bot/SharePagePage.vue')
const LenhBotRevokePagePage = () => import('@/pages/lenh-bot/RevokePagePage.vue')
const LenhBotScanBmPage = () => import('@/pages/lenh-bot/ScanBmPage.vue')
const LenhBotCheckTkqcPage = () => import('@/pages/lenh-bot/CheckTkqcPage.vue')
const LenhBotSharePixelPage = () => import('@/pages/lenh-bot/SharePixelPage.vue')
const LenhBotCreateCataloguePage = () => import('@/pages/lenh-bot/CreateCataloguePage.vue')
const LenhBotSetLimitPage = () => import('@/pages/lenh-bot/SetLimitPage.vue')
const LenhBotRemoveLimitPage = () => import('@/pages/lenh-bot/RemoveLimitPage.vue')
const LenhBotRenameTkqcPage = () => import('@/pages/lenh-bot/RenameTkqcPage.vue')
const LenhBotRenamePagePage = () => import('@/pages/lenh-bot/RenamePagePage.vue')
const FacebookOAuthCallbackPage = () => import('@/pages/FacebookOAuthCallbackPage.vue')
const LicenseKeyManagementPage = () => import('@/pages/LicenseKeyManagementPage.vue')

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    meta: { 
      requiresGuest: true,
      title: 'Đăng nhập'
    }
  },
    {
        path: '/facebook-oauth-callback',
        name: 'FacebookOAuthCallback',
        component: FacebookOAuthCallbackPage,
        meta: {
            title: 'Facebook OAuth',
            requiresAuth: false
        }
    },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { 
      requiresAuth: true 
    },
    children: [
      {
        path: '',
        redirect: '/admin/assets'
      },
      {
        path: 'assets',
        name: 'Assets',
        component: AssetsPage,
        meta: { 
          title: 'Quản lý tài sản',
          permission: 'view-ad-accounts'
        }
      },
      {
        path: 'cs-management',
        name: 'CsManagement',
        component: CsManagementPage,
        meta: {
          title: 'Quản lý CS',
          permission: 'view-ad-accounts'
        }
      },
      {
        path: 'lenh-bot',
        redirect: { name: SHARE_TKQC_ROUTE_NAME }
      },
      {
        path: 'lenh-bot/share-tkqc',
        name: SHARE_TKQC_ROUTE_NAME,
        component: LenhBotShareTkqcPage,
        meta: {
          title: 'Share TKQC',
          permission: 'view-ad-accounts'
        }
      },
      {
        path: 'lenh-bot/share-page',
        name: 'SharePageConfig',
        component: LenhBotSharePagePage,
        meta: {
          title: 'Cấu hình Share Page',
          permission: 'view-ad-accounts'
        }
      },
      {
        path: 'lenh-bot/share-pixel',
        name: SHARE_PIXEL_ROUTE_NAME,
        component: LenhBotSharePixelPage,
        meta: {
          title: 'Cấu hình Share Pixel',
          permission: 'view-ad-accounts'
        }
      },
      {
        path: 'lenh-bot/create-catalogue',
        name: CREATE_CATALOGUE_ROUTE_NAME,
        component: LenhBotCreateCataloguePage,
        meta: {
          title: 'Cấu hình Create Catalogue',
          permission: 'view-ad-accounts'
        }
      },
      {
        path: 'lenh-bot/revoke-page',
        name: 'RevokePageConfig',
        component: LenhBotRevokePagePage,
        meta: {
          title: 'Cấu hình thu hồi Page',
          permission: 'view-ad-accounts'
        }
      },
      {
        path: 'lenh-bot/scanbm',
        name: LENH_BOT_SCANBM_ROUTE_NAME,
        component: LenhBotScanBmPage,
        meta: {
          title: 'Scan BM',
          permission: 'view-ad-accounts'
        }
      },
      {
        path: 'lenh-bot/check-tkqc',
        name: LENH_BOT_CHECKTKQC_ROUTE_NAME,
        component: LenhBotCheckTkqcPage,
        meta: {
          title: 'Check TKQC',
          permission: 'view-ad-accounts'
        }
      },
      {
        path: 'lenh-bot/set-limit',
        name: SET_LIMIT_ROUTE_NAME,
        component: LenhBotSetLimitPage,
        meta: {
          title: 'Set Limit',
          permission: 'view-ad-accounts'
        }
      },
      {
        path: 'lenh-bot/remove-limit',
        name: REMOVE_LIMIT_ROUTE_NAME,
        component: LenhBotRemoveLimitPage,
        meta: {
          title: 'Remove Limit',
          permission: 'view-ad-accounts'
        }
      },
      {
        path: 'lenh-bot/rename-tkqc',
        name: RENAME_TKQC_ROUTE_NAME,
        component: LenhBotRenameTkqcPage,
        meta: {
          title: 'Rename TKQC',
          permission: 'view-ad-accounts'
        }
      },
      {
        path: 'lenh-bot/rename-page',
        name: RENAME_PAGE_ROUTE_NAME,
        component: LenhBotRenamePagePage,
        meta: {
          title: 'Rename Page',
          permission: 'view-ad-accounts'
        }
      },
      {
        path: 'users',
        name: 'UserManagement',
        component: UserManagementPage,
        meta: {
          title: 'Quản lý người dùng',
          permission: 'view-users'
        }
      },
      {
        path: 'roles',
        name: 'RolePermission',
        component: RolePermissionPage,
        meta: {
          title: 'Vai trò & Quyền hạn',
          permission: 'view-roles'
        }
      },
      {
        path: 'license-keys',
        name: 'LicenseKeys',
        component: LicenseKeyManagementPage,
        meta: {
          title: 'Quản lý Key phần mềm',
          permission: 'manage-license-keys'
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guards
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()

  // Set page title
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} - ${import.meta.env.VITE_APP_TITLE || 'Ads Management'}`
  }

  // Check authentication requirement
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!authStore.isLoggedIn) {
      next({ 
        path: '/login', 
        query: { redirect: to.fullPath } 
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

// Handle navigation errors
router.onError((error) => {
  console.error('Router error:', error)
})

export default router
